module.exports = __webpack_public_path__ + "static/travelzik1-d94101f7efc76ed7b46dce65fc5b5b55.jpg";